import React from 'react';
import {
  FmMapViewportContext,
  type FmMapViewportController,
} from './FmMapViewportContext';

export const FmMapViewportProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [controller, register] = React.useState<FmMapViewportController | null>(null);
  const value = React.useMemo(() => ({ controller, register }), [controller]);
  return (
    <FmMapViewportContext.Provider value={value}>
      {children}
    </FmMapViewportContext.Provider>
  );
};
